module.exports = __webpack_public_path__ + "img/kt.f0b0da84.svg";